import {RefObject, useEffect} from 'react';

import {isIOS} from '@zzng/common/utils/agent';

import {isUnderKakaoTalkVersion} from '@/root/utils/isRequiredKakaoTalkVersion';

// 웹뷰 이동시 흰화면이 노출되는 경우를 대응한 코드
// https://jira.daumkakao.com/browse/CARD-650
export const useVisibilityAOS = (containerRef: RefObject<HTMLDivElement>) => {
  const handler = () => {
    if (!containerRef.current) return;
    const scrollTop = containerRef.current.scrollTop || 0;

    if (document.visibilityState === 'hidden') {
      containerRef.current.scrollTo(0, scrollTop + 1);
    } else {
      containerRef.current.scrollTo(0, scrollTop - 1);
    }
  };

  useEffect(() => {
    if (isIOS) return;
    // TODO: 10.3.0 점유율이 90% 이상일때 코드 제거 필요
    if (!isUnderKakaoTalkVersion) return;

    document.addEventListener('visibilitychange', handler);
    return () => {
      document.removeEventListener('visibilitychange', handler);
    };
  }, []);
};
